import React from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { FilterDropdown, FilterChipRow } from "/imports/ui/components/shared";
import { INVOICE_STATUS_OPTIONS, INVOICE_SORT_OPTIONS } from "../dashboardConstants";

function InvoiceFilters({ status, sort, onStatusChange, onSortChange }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Phones get the status chips collapsed into a dropdown, paired with sort on
  // one row, to match the Bookings filter layout.
  if (isMobile) {
    return (
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <FilterDropdown
          options={INVOICE_STATUS_OPTIONS}
          value={status}
          onChange={onStatusChange}
          placeholder="All statuses"
          fullWidth
          minWidth={0}
          active={Boolean(status)}
        />
        <FilterDropdown
          options={INVOICE_SORT_OPTIONS}
          value={sort}
          onChange={(v) => onSortChange(v || "date")}
          allowAll={false}
          fullWidth
          minWidth={0}
          active={sort === "amount"}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5, mb: 2 }}>
      <FilterChipRow options={INVOICE_STATUS_OPTIONS} value={status} onSelect={onStatusChange} allowClear />
      <Box sx={{ ml: { sm: "auto" } }}>
        <FilterDropdown
          options={INVOICE_SORT_OPTIONS}
          value={sort}
          onChange={(v) => onSortChange(v || "date")}
          allowAll={false}
          active={sort === "amount"}
        />
      </Box>
    </Box>
  );
}

export default InvoiceFilters;
